export default function CsharpMultidArrays() {
  return (
    <h2>Csharp MultiD Arrays</h2>
  );
}
